import {
  GET_PROFILE_SETTINGS_SUCCESS,
  SET_PROFILE_SETTINGS_LOADING,
  CHANGE_PASSWORD,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_ERROR,
  CHANGE_PERMISSIONS_SUCCESS,
  GET_CURRENT_USER_SUCCESS,
  SIGNOUT_USER_SUCCESS,
  CLEAR_PROFILE_TEMP_DATA,
  GET_SCHOOL_BY_TENANT_SUCCESS,
  GET_SCHOOL_BY_TENANT_ERROR,
  GET_SCHOOL_BY_TENANT,
  GET_ROUTES_FOR_PROFILE_SUCCESS,
} from '../constants/ActionTypes';
import { RequestStatus } from '../models/requestStatus';

const INIT_STATE = {
  user: null,
  loadingUser: false,
  settings: null,
  loadingSettings: false,
  changePasswordRequestStatus: new RequestStatus(),
  userRoutes: [],
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_CURRENT_USER_SUCCESS:
      return {
        ...state,
        user: action.payload.user,
      };
    case GET_PROFILE_SETTINGS_SUCCESS:
      return {
        ...state,
        settings: action.payload.settings,
      };
    case SET_PROFILE_SETTINGS_LOADING:
      return {
        ...state,
        loadingSettings: action.payload.isLoading,
      };
    case CHANGE_PASSWORD:
      return {
        ...state,
        changePasswordRequestStatus: new RequestStatus(true),
      };
    case CHANGE_PASSWORD_SUCCESS:
      return {
        ...state,
        changePasswordRequestStatus: new RequestStatus(false, true),
      };
    case CHANGE_PASSWORD_ERROR:
      return {
        ...state,
        changePasswordRequestStatus: new RequestStatus(false, false, action.payload),
      };
    case CHANGE_PERMISSIONS_SUCCESS:
      return {
        ...state,
        settings: {
          ...(state.settings || {}),
          ...action.payload.permissions,
        },
      };
    case SIGNOUT_USER_SUCCESS:
      return INIT_STATE;
    case CLEAR_PROFILE_TEMP_DATA: {
      return {
        ...INIT_STATE,
        user: state.user,
      };
    }
    case GET_SCHOOL_BY_TENANT: {
      return {
        ...state,
        isLoadingSchool: true,
      };
    }
    case GET_SCHOOL_BY_TENANT_ERROR: {
      return {
        ...state,
        isLoadingSchool: false,
      };
    }
    case GET_SCHOOL_BY_TENANT_SUCCESS: {
      return {
        ...state,
        isLoadingSchool: false,
        school: action.payload.school,
      };
    }
    case GET_ROUTES_FOR_PROFILE_SUCCESS: {
      return {
        ...state,
        userRoutes: action.payload.routes,
      };
    }
    default:
      return state;
  }
};
